import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';
import {minValue, maxValue} from '../../common/components/form/common/fieldValidations';

const INITIAL_STATE_EXEMPTION_MANAGEMENT = {
  'list': [],
  'loading': false,
  'minValueFrom': minValue(1),
  'minValueTo': minValue(2),
  'minValue': 0,
};

const FORM_INITIAL_STATE = {
  'loading': false,
  'values': {
    'disabilityPercentajeFrom': '',
    'disabilityPercentajeTo': '',
    'exonerationPercentaje': '',
  },
};

export const exemptionManagment = (state, action) => {
  return createReducer(INITIAL_STATE_EXEMPTION_MANAGEMENT, {
    [ActionTypes.FETCHING_EXEMPTION_MANAGEMENT_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_EXEMPTION_MANAGEMENT_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
      'minValueFrom': minValue(action.response.minValue),
      'minValue': action.response.minValue,
    }),
    [ActionTypes.FETCHED_EXEMPTION_MANAGEMENT_LIST_FAILED]: (
      state,
      action
    ) => ({
      ...state,
      'loading': false,
      'list': [],
      'minValueFrom': minValue(1),
      'minValueTo': minValue(2),
    }),
    [ActionTypes.SET_DISABILITY_VALUE_FROM]: (state, action) => {
      const {name, value, id} = action.payload;
      const existValue = state.list.find(
        (item) =>
          item.disabilityPercentajeFrom <= value &&
          value <= item.disabilityPercentajeTo && item.id !== id
      );
      const minValueFrom = existValue && name === 'disabilityPercentajeFrom' ?
        minValue(existValue.disabilityPercentajeTo + 1) : null;
      const minValueTo = existValue && name === 'disabilityPercentajeTo' ?
        maxValue(existValue.disabilityPercentajeFrom - 1) : null;

      return {
        ...state,
        'minValueFrom': minValueFrom,
        'minValueTo': minValueTo,
      };
    },
    [ActionTypes.CLEAR_EXEMPTION_MANAGEMENT_LIST]: (state, action) => ({
      ...state,
      ...INITIAL_STATE_EXEMPTION_MANAGEMENT,
    }),
  })(state, action);
};

export const exemptionManagementForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.FETCHING_EXEMPTION_MANAGEMENT_INFO]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_EXEMPTION_MANAGEMENT_INFO]: (state, action) => ({
      ...state,
      'loading': true,
      'values': {
        ...state.values,
        'disabilityPercentajeFrom':
          action.response.data.disabilityPercentajeFrom,
        'disabilityPercentajeTo': action.response.data.disabilityPercentajeTo,
        'exonerationPercentaje': action.response.data.exonerationPercentaje,
      },
    }),
    [ActionTypes.FETCHED_EXEMPTION_MANAGEMENT_INFO_FAILED]: (state) => ({
      ...state,
      'loading': false,
      'values': {
        ...state.values,
        'disabilityPercentajeFrom': '',
        'disabilityPercentajeTo': '',
        'exonerationPercentaje': '',
      },
    }),
    [ActionTypes.CLEAR_EXEMPTION_MANAGEMENT_INFO]: (state) => ({
      ...state,
      'loading': false,
      'values': {
        ...state.values,
        'disabilityPercentajeFrom': '',
        'disabilityPercentajeTo': '',
        'exonerationPercentaje': '',
      },
    }),
  })(state, action);
};
